
import { getAimsUrlFlavor } from 'lib/getAimsUrl';
import { isAimsUrl, isResizableImage } from 'lib/isAimsUrl';
import AIMS_FLAVORS from 'lib/aimsFlavors';
import { getTelemundoImageSrc } from 'lib/imageUtils';
import { isTelemundoVertical } from 'lib/vertical';

const aimsFlavorFor = (platform, vertical) => {
  const isVerticalTodayDotCom = (vertical === 'today');

  switch (platform) {
    case 'og':
      return isVerticalTodayDotCom
        ? AIMS_FLAVORS.SOCIAL_SHARE_OG_TODAY
        : AIMS_FLAVORS.SOCIAL_SHARE_OG;
    case 'twitter':
      return isVerticalTodayDotCom
        ? AIMS_FLAVORS.SOCIAL_SHARE_TWITTER_TODAY
        : AIMS_FLAVORS.SOCIAL_SHARE_TWITTER;
    default:
      return AIMS_FLAVORS.SOCIAL_SHARE_DEFAULT;
  }
};

const attribution = (profile = null, vertical = null) => {
  if (profile && profile.twitter) {
    const url = profile.twitter.replace(/\/+$/, '');
    return url.substr(url.lastIndexOf('/') + 1);
  }
  if (vertical === 'msnbc') {
    return 'MSNBC';
  }
  if (vertical === 'noticias') {
    return 'TelemundoNews';
  }
  if (vertical === 'entretenimiento') {
    return 'Telemundo';
  }
  if (vertical === 'shows') {
    return 'Telemundo';
  }
  if (vertical === 'telemundo') {
    return 'Telemundo';
  }
  return 'NBCNews';
};

const defaultImage = (vertical) => {
  if (vertical === 'today') {
    return 'https://nodeassets.nbcnews.com/cdnassets/projects/today-socialshareimages-bento/Today-og-image.png';
  }

  if (vertical === 'noticias') {
    return 'https://media4.s-nbcnews.com/i/newscms/2020_04/3196111/telemundo_social_image_e00f8bf16b45eaa533c946692771742d.png';
  }

  return 'https://nodeassets.nbcnews.com/cdnassets/projects/socialshareimages-bento/og-nbcnews1200x630.png';
};

const shareImage = (imageUrl, vertical, platform = null) => {
  if (!isResizableImage(imageUrl)) {
    return defaultImage(vertical);
  }

  if (isAimsUrl(imageUrl)) {
    return imageUrl;
  }

  if (isTelemundoVertical(vertical)) {
    return getTelemundoImageSrc(imageUrl, aimsFlavorFor(platform, vertical));
  }

  return getAimsUrlFlavor(imageUrl, { flavor: aimsFlavorFor(platform, vertical) });
};

const sanitize = (profile) => {
  if (profile) {
    return profile.replace('@', '').trim().split('/').pop();
  }
  return null;
};

const profileURL = {
  facebook: 'https://www.facebook.com/',
  instagram: 'https://instagram.com/',
  pinterest: 'https://pinterest.com/',
  twitter: 'https://twitter.com/',
  youtube: 'https://www.youtube.com/user/',
};

const reTrim = /\/$/m;
const reChars = /(\/|@)/m;

const getProfileURL = (network, handle) => {
  if (typeof network === 'string'
  && typeof profileURL[network] !== 'undefined'
  && typeof handle === 'string'
  && handle.length) {
    let trimmed = handle.trim().replace(reTrim, '');
    const splitOnInvalidChars = trimmed.split(reChars);
    if (Array.isArray(splitOnInvalidChars) && splitOnInvalidChars.length > 0) {
      trimmed = splitOnInvalidChars[splitOnInvalidChars.length - 1];
    }
    return `${profileURL[network]}${trimmed}`;
  }
  return null;
};

export {
  aimsFlavorFor,
  attribution,
  defaultImage,
  getProfileURL,
  sanitize,
  shareImage,
};
